import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable, first, map } from 'rxjs';
import { FrequencyRange, TenantId } from "@allbesmart/web-app-common";
import { RanConfigurationDto } from "../models/ran-configuration/ran-configuration-dto";
import { HTTP_ENDPOINTS } from "../external/http";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class RanConfigurationService {

  private fullRanConfigurationChanges: EventEmitter<{ tenantId: TenantId }> = new EventEmitter();

  constructor(private http: HttpClient) { }

  public fetchDefaultRanConfiguration(frequencyRange: FrequencyRange): Observable<RanConfigurationDto> {
    return this.http.get<RanConfigurationDto>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.FETCH_DEFAULT_CONFIGURATION}/${frequencyRange}`)
      .pipe(first());
  }

  public fetchCustomRanConfiguration(tenantId: TenantId): Observable<RanConfigurationDto> {
    return this.http.get<RanConfigurationDto>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.GET_CUSTOM_CONFIGURATION}/${tenantId}`)
      .pipe(first());
  }

  public createOrUpdateRanCustomConfiguration(gnbCustomConfigurationDto: RanConfigurationDto, tenantId: TenantId): Observable<RanConfigurationDto> {
    return this.http.post<RanConfigurationDto>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.CREATE_OR_UPDATE_CUSTOM_CONFIGURATION}/${tenantId}`, gnbCustomConfigurationDto)
      .pipe(first());
  }

  public createOrUpdateDefaultRanConfiguration(gnbDefaultConfigurationDto: RanConfigurationDto, frequencyRange: FrequencyRange): Observable<RanConfigurationDto> {
    return this.http.post<RanConfigurationDto>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.CREATE_OR_UPDATE_DEFAULT_CONFIGURATION}/${frequencyRange}`, gnbDefaultConfigurationDto)
      .pipe(first());
  }

  public deleteCustomRanConfiguration(tenantId: TenantId): Observable<void> {
    return this.http.delete<void>(`${environment.apiBasePath}/${HTTP_ENDPOINTS.DELETE_CUSTOM_CONFIGURATION}/${tenantId}`)
      .pipe(first(), map(() => this.fullRanConfigurationChanges.emit({ tenantId })));
  }
}
